import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import LoginModal from '../LoginModal';
import ServicesSection from '../ServicesSection';
import SEO from '../SEO';
import { Badge } from '../ui/badge';

const ProjetosPage = () => {
  const navigate = useNavigate();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <>
      <SEO 
        title="AJ|BIM Projetos - Arquitetura, Engenharia e As Built"
        description="Projetos de Arquitetura, Engenharia, Infraestrutura, As Built com Scanners e Drones, Planejamento 4D e Orçamentação 5D."
        keywords="projetos BIM, arquitetura BIM, engenharia BIM, as built, planejamento 4D, orçamentação 5D"
      />
      <Header onLoginClick={() => setIsLoginModalOpen(true)} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-green-900/30 via-black to-black">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="bg-green-600/20 text-green-400 border-green-500/30 mb-4">
              AJ|BIM Projetos
            </Badge>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Projetos e <span className="text-green-500">Serviços BIM</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Arquitetura, Engenharia, Infraestrutura, As Built com tecnologia de ponta, 
              Planejamento 4D e Orçamentação 5D.
            </p>
          </div>
        </div>
      </section>

      {/* Services & Projects */}
      <ServicesSection />

      {/* Voltar */}
      <section className="py-12 bg-black">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="border-zinc-700 text-white hover:bg-zinc-800"
          >
            <ArrowLeft className="mr-2" size={18} />
            Voltar ao Portal
          </Button>
        </div>
      </section>

      <Footer />
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </>
  );
};

export default ProjetosPage;
